import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CheckBoxList from '../../Components/CheckBoxList';
import { useUser } from '../../../Providers/UserProvider';


const InputUserDataPanel = ({ handleSaveUserButtonClick, user, handleChange, isEdit, selectedRoles, setSelectedRoles, error }) => {
    const { t } = useTranslation();
    const { userRoles } = useUser()

    return <>
        <div className="cont profile-details-info">
            <div className="row data-container mb-0">
                <h3 className="checkbox-list-title">{t("user")}
                    <span className='error-text-color'> *</span>
                </h3>
            </div>
            <div className="row data-container">
                <div className="col-12 col-md">
                    <Form.Control id='firstNameControl' name='firstName' maxLength={30} type='text' placeholder={t("name")} value={user.firstName} onChange={handleChange} autoFocus />
                </div>
                <div className="col-12 col-md mt-2 mt-md">
                    <Form.Control id='lastNameControl' name='lastName' maxLength={50} type='text' placeholder={t("surname")} value={user.lastName} onChange={handleChange} />
                </div>
            </div>
            <div className="row data-container">
                <div className="col-12 col-md">
                    <Form.Control name='userLogin' placeholder='E-mail' maxLength={60} value={user.userLogin} onChange={handleChange} />
                </div>
                <div className="col-12 col-md mt-2 mt-md d-flex align-items-center">
                    <PhoneInput
                        country={'pl'}
                        value={user.phoneNumber}
                        onChange={(phone) => handleChange({ target: { name: 'phoneNumber', value: phone } })}
                        inputProps={{ name: 'phoneNumber' }}
                        inputClass="form-control"
                        containerClass="flex-grow-1"
                        inputStyle={{ width: '100%', paddingLeft: '52px' }}
                        enableSearch
                        searchPlaceholder="Szukaj kraju"
                        searchNotFound="Nie znaleziono"
                    />
                </div>
            </div>
        </div>
        <div className="cont profile-details-info">
            <div className="row data-container">
                <CheckBoxList title={'Poziom uprawnień'} userRoles={userRoles} selectedRoles={selectedRoles} setSelectedRoles={setSelectedRoles} />
            </div>
        </div>
        <div className="cont profile-details-info">
            <div className="row data-container">
                <span>
                    <span className='error-text-color'>*</span> Pole wymagane
                </span>
            </div>
        </div>
        <div className="cont profile-details-info">
            <div className="row data-container">
                <div className="col-12 col-md d-grid">
                    <button className='btn-app-secondary mt-3' onClick={handleSaveUserButtonClick}>
                        {isEdit ? 'Zapisz zmiany' : 'Dodaj użytkownika'}
                    </button>
                </div>
                <div className="col d-grid">
                </div>
            </div>
        </div>

        {error.length > 0 ? (<div className="row error-text-color justify-content-center mb-4">{error}</div>) : (<></>)}
    </>
}
export default InputUserDataPanel;